import theme from '@styles/theme';
export default {
  mapSection: {
    p: ['0 16px', '0 16px', '0 24px', '0 40px']
  },
  filterHeader: {
    background: theme.rawColors.lightGrey300,
    m: '0 0 10px',
    p: '24px 0',
    gridTemplateColumns: ['2fr', '2fr', '2fr', '1fr 1fr']
  },
  mapRow: {
    background: theme.rawColors.lightGrey300,
    m: '0',
    gap: 0,
    gridTemplateColumns: ['24fr', '24fr', '24fr', '10fr 14fr']
  },
  locationCol: {
    p: ['24px 12px !important', '24px !important']
  },
  locationList: (counter: number) => ({
    height: counter < 3 ? ['auto', 'auto', 'auto', '552px'] : ['440px', '440px', '440px', '552px'],
    overflow: 'auto'
  }),
  mapCol: {
    p: '0 !important'
  }
};